import React from 'react';
import {
    Header,
    Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Checkbox, Grid
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import Modal from "react-responsive-modal";

// import styled, { keyframes } from 'styled-components';
// import { fadeIn } from 'react-animations';
import { Link } from 'react-router-dom';
import CourseList from './CourseList';


export default class PollCourseListPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false

        };

    }

    render() {
        return (

            <div>

                <Header as="h2"> Ankete </Header>
                <Segment.Group clearing raised >
                    <Segment> <Header as="h3"> Predmeti </Header></Segment>
                    <Segment><CourseList /></Segment>

                </Segment.Group>


            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/StudentPoll/PollCourseListPreview.js